var map = {
	"./burger.svg": "2e69",
	"./cards/404.svg": "f13c",
	"./cards/problems/button.svg": "9507",
	"./cards/selection.svg": "0e57",
	"./cards/show/left.svg": "89c2",
	"./cards/show/right.svg": "210b",
	"./close.svg": "bf37",
	"./donate/tinkoff.svg": "c0aa",
	"./donate/vk.svg": "cd67",
	"./error.svg": "2ee5",
	"./invest/arrow_right.svg": "87c6",
	"./invest/bgg.svg": "5c5b",
	"./invest/glow.svg": "c32a",
	"./invest/hands.svg": "b9b7",
	"./invest/map/en.svg": "57d8",
	"./invest/map/ru.svg": "8404",
	"./invest/mapp.svg": "1dc3",
	"./invest/mhands.svg": "aa4b",
	"./invest/smhands.svg": "df3c",
	"./invest/star.svg": "83f7",
	"./join.svg": "7122",
	"./logo.svg": "9b19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";